export default {
    displayPcAdArea(e, shouldDisplay) {
        e.preventDefault();
        this.displayPcAdAreaAction(shouldDisplay);
    },
    displayPcAdAreaAction(shouldDisplay) {
        this.setState({displayPcAd: shouldDisplay});
    },
    displayMobileAdAreaAction(shouldDisplay) {
        this.setState({displayMobileAd: shouldDisplay});
    },
    setOsAction(os) {
        this.setState({os: os});
    }
}


// WEBPACK FOOTER //
// ./src/components/mixins/adArea.js